import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-select', {
    name: 'ak-select',
    mixins: [FormElementMixin],
    data() {
        return {
            scrollParent: null
        }
    },
    props: {
        selectOptions: {
            type: Array,
            required: false,
            default: () => []
        },
        allowMultiple: {
            type: Boolean | Number,
            required: false,
            default: false
        },
        clearable: {
            type: Boolean,
            required: false,
            default: true
        },
        searchable: {
            type: Boolean,
            required: false,
            default: true
        },
        position: {
            type: String,
            required: false,
        },
        appendToBodyOption: {
            type: Boolean,
            required: false,
            default: null
        }
    },
    computed: {
        multiple() {
            return this.allowMultiple == 1;
        },
        appendToBody() {
            if (this.appendToBodyOption !== null) {
                return this.appendToBodyOption;
            }

            // we check if we are in a ak-form
            // if so we will not append to the body as this cases click outside + positioning issues beceause there is an extra scrollbar
            let parent = this.$parent;
            while (parent) {
                parent = parent.$parent;
                if (parent && parent.$options.name == "ak-form") {
                    return false;
                }
            }

            return true;
        }
    },
    methods: {
        reduce(option) {
            return option.value;
        },
        getOptionLabel(option) {
            if (typeof option === 'object') {
                if (!option.hasOwnProperty('label')) {
                    return console.warn(
                        `[vue-select warn]: Label key "option.label" does not` +
                        ` exist in options object ${JSON.stringify(option)}.\n` +
                        'https://vue-select.org/api/props.html#getoptionlabel'
                    )
                }
                if (typeof option.label === 'object') {
                    return option.label.label;
                }

                return option.label;
            }
            return option;
        },
        addScrollEvent() {
            if (typeof(this.$parent) === 'undefined') {
                return;
            }

            let parent = this.$parent.$el;

            if (parent.closest('.ak-filter-dropdown')) {
                parent = parent.closest('.ak-filter-dropdown');
            }

            this.scrollParent = parent;
            this.scrollParent.addEventListener('scroll', this.updateDropdownPosition);
        },
        removeScrollEvent() {
            if ( ! this.scrollParent) {
                return;
            }

            this.scrollParent.removeEventListener('scroll', this.updateDropdownPosition);
            this.scrollParent = null;
        },
        updateDropdownPosition() {
            const $select = this.$refs.select;
            const dropdown = document.querySelector(".vs__dropdown-menu");
            if (dropdown && (!this.position || this.position === 'bottom')) {
                dropdown.style.position = "absolute";
                dropdown.style.top = `${$select.$el.getBoundingClientRect().bottom + window.scrollY}px`;
                dropdown.style.left = `${$select.$el.getBoundingClientRect().left}px`;
                dropdown.style.width = `${$select.$el.offsetWidth}px`;
            } else if(dropdown && (!this.position || this.position === 'top') ) {
                dropdown.style.position = "absolute";
                dropdown.style.top = `${$select.$el.getBoundingClientRect().top - dropdown.offsetHeight}px`;
                dropdown.style.left = `${$select.$el.getBoundingClientRect().left}px`;
                dropdown.style.width = `${$select.$el.offsetWidth}px`;
                dropdown.classList.add('vs__dropdown-menu--top');
            } else if(dropdown && (!this.position || this.position === 'top-right') ) {
                dropdown.style.position = "absolute";
                dropdown.style.top = `${$select.$el.getBoundingClientRect().top - dropdown.offsetHeight}px`;
                dropdown.style.left = `${$select.$el.getBoundingClientRect().left - dropdown.offsetWidth + $select.$el.offsetWidth}px`;
                dropdown.style.width = `${$select.$el.offsetWidth}px`;
                dropdown.classList.add('vs__dropdown-menu--top');
            }
        },
        async dropdownOpen() {
            if (! this.appendToBody) {
                return;
            }

            await this.$nextTick(); // Wait for DOM update

            this.addScrollEvent();
            this.updateDropdownPosition();
        }
    }
}, 'form/controls/ak-select.html');